import React from "react";
import styles from "./index.module.scss";
import CheckmarkIcon from "assets/icons/checkmark.svg?react";
import { useTranslation } from "react-i18next";

export interface ConnectedIndicatorProps {
    connected: boolean;
    connectedText?: string;
    disabledText?: string;
}

export const ConnectedIndicator: React.FC<ConnectedIndicatorProps> = ({
    connected,
    connectedText,
    disabledText
}: ConnectedIndicatorProps) => {
    const { t } = useTranslation();

    return (
        <>
            <div className={styles["connected-indicator"]}>
                {connected ? (
                    <CheckmarkIcon className={styles["check-icon"]} />
                ) : null}
                <div
                    className={`${
                        !connected
                            ? styles["disabled-text"]
                            : styles["connected-text"]
                    }`}
                >
                    {connected
                        ? connectedText ?? t("widgets:connected")
                        : disabledText ?? t("widgets:disconnected")}
                </div>
            </div>
        </>
    );
};
